import axios from "./axios";

export const learnerAnnualQuestionnaireUpdate = (
  payload
) =>
  axios
    .post("/annual-questionnaire/learner", payload)
    .then((res) => res.data);

